import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps, SitecoreContextValue } from 'src/lib/ComponentProps';

import ContentOverviewHeaderContainer from 'src/components/contentOverview/_contentOverviewHeaderContainer/ContentOverviewHeaderContainer';
import ContentOverviewActionButton from 'src/components/contentOverview/contentOverviewActionButton/ContentOverviewActionButton';

import { CourseFields } from '../CourseFields';

type CourseOverviewSignUpProps = ComponentProps & {
	fields: CourseFields;
};

export default function CourseOverviewSignUp(props: CourseOverviewSignUpProps): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue>();

	return (
		<div>
			<ContentOverviewHeaderContainer header={sitecoreContext.dictionary.signUpTitle} />
			<Text field={{ value: sitecoreContext.dictionary.completeFormText }} />
			<ContentOverviewActionButton registerYourInterestOnly removePadding {...props} />
		</div>
	);
}
